import React from "react";
import { Card, CardBody, CardTitle, CardSubtitle, CardText } from "reactstrap";

const StudentSchool = props => {
  return (
    <Card>
      <CardBody>
        <CardTitle className="text-success">
          <strong>{props.school.className}</strong>
        </CardTitle>
        <CardSubtitle>{props.school.schoolName}</CardSubtitle>
        <CardText />
      </CardBody>
    </Card>
  );
};

export default StudentSchool;
